import type ProjectionPlace from "./interfaces/ProjectionPlace.ts";

function initPartnersView() {
    const partnersView = document.getElementById('partners') as HTMLDivElement | null;
    const projectionPlacesFilter = document.getElementById('projection-places-filter') as HTMLSelectElement | null;

    if (partnersView == null || projectionPlacesFilter == null) {
        return;
    }

    let locationsData: ProjectionPlace[] = JSON.parse((document.getElementById("locations-data")! as HTMLScriptElement).text);

    projectionPlacesFilter.addEventListener('change', function () {
        const locationData = locationsData.find(
            (element) => element.slug === projectionPlacesFilter.value
        );

        if (locationData) {
            partnersView.innerHTML = "<strong>Projections présentées avec le soutien de :</strong><br>"
            partnersView.innerHTML += locationData.partners.map(
                (partner) => `<img src="${partner.imageUrl}" alt="${partner.editionCse}" />`
            ).join('');
        } else {
            partnersView.innerHTML = '';
        }
    })
}

initPartnersView();
